import { validator } from '../libraries'
import isEmpty from 'lodash'

export const validateInput = (data) => {
  let errors = {}

  if (validator.isEmpty(data.email)) {
    errors.email = 'email salah'
  }

  if (validator.isEmpty(data.password)) {
    errors.password = 'password salah'
  }

  return {
    errors,
    isValid: isEmpty(errors)
  }
}